<template>
	<div class="select-container">
		<div @click="isHidden = !isHidden">
			<slot name="select"></slot>
		</diV>
		<div :class="[isHidden ? 'hidden-options slidedown' : 'hidden-options slideup']">
			<slot name="hidden"></slot>
		</diV>
	</diV>
</template>

<script>

	export default {

		data () {
			return {
				isHidden: false
			}
		},

		mounted() {

		},

	}
</script>

<style>
.select-container .slideup, .select-container .slidedown {
	max-height: 0;
	overflow-y: hidden;
	transition: max-height 0.3s ease-in-out;
}
.select-container .slidedown {
	max-height: 140px ;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/CustomSelect.vue